import { Lang } from './lang';

export class FVEnviroment {
  constructor(
    public debug?: boolean,
    public apiUrl?: string,
    public defaultLanguage?: Lang,
    public languages?: Lang[],
    public lowerCaseTranslates?: boolean,
  ) { }
}
